module.exports = __webpack_public_path__ + "static/media/powerbutton.8c383c7c.jpg";